import { FC } from "react";
import { Heading } from "@chakra-ui/react";
import { AnimationControls, motion } from "framer-motion";

const MotionHeading = motion(Heading);

interface Props {
  controls: AnimationControls;
  text: string;
}

export const LoadingHeading: FC<Props> = ({ controls, text }) => {
  return (
    <MotionHeading
      animate={controls}
      initial={{ opacity: 0 }}
      mb={16}
      textAlign="center"
      variant="th-h2"
    >
      {text}
    </MotionHeading>
  );
};
